module.exports = __webpack_public_path__ + "img/user.6d60fbaa.png";